import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const quinceImg = '/assets/img/quince.png';

const AgeVerificationModal = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('ageVerified') !== 'true') {
      setIsOpen(true);
      document.body.style.overflow = 'hidden';
    }
    return () => { document.body.style.overflow = ''; };
  }, []);

  const handleAccept = () => {
    localStorage.setItem('ageVerified', 'true');
    setIsOpen(false);
    document.body.style.overflow = '';
  };

  const handleDecline = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!isOpen) return null;

  return (
    /* Overlay : fixed plein ecran, z-index tres eleve, fond sombre */
    <div
      className="fixed inset-0 flex items-center justify-center p-6"
      style={{ backgroundColor: 'rgba(23,18,13,0.88)', zIndex: 9999, backdropFilter: 'blur(4px)' }}
    >
      {/* Carte modale */}
      <div
        className="relative w-full max-w-md rounded-3xl overflow-hidden shadow-2xl text-center"
        style={{ backgroundColor: '#FBF7EF' }}
      >
        {/* Coings decoratifs sur les cotes */}
        <img src={quinceImg} alt="" aria-hidden="true"
          className="absolute top-4 -left-6 w-20 opacity-[0.07] pointer-events-none" />
        <img src={quinceImg} alt="" aria-hidden="true"
          className="absolute bottom-4 -right-6 w-20 opacity-[0.07] pointer-events-none" />

        {/* Contenu */}
        <div className="relative px-8 py-10">
          {/* Liseré doré en haut */}
          <div
            className="absolute top-0 left-8 right-8 h-px"
            style={{ background: 'linear-gradient(90deg, transparent, rgba(217,166,65,0.6), transparent)' }}
          />

          <span className="text-xs font-semibold tracking-[0.3em] uppercase text-amber-800">
            Accès au site
          </span>

          <h2 className="font-sans mt-4 text-2xl md:text-3xl text-stone-900">
            {t('age_verification.title')}
          </h2>

          <p className="font-nunito mt-4 text-stone-600 leading-relaxed">
            {t('age_verification.description')}
          </p>

          <div className="mt-8 flex flex-col gap-3">
            {/* Bouton Oui */}
            <button
              onClick={handleAccept}
              className="w-full font-sans tracking-wide rounded-xl py-3.5 text-white transition-all duration-300 hover:opacity-90 hover:scale-[1.02]"
              style={{ backgroundColor: '#2E2318' }}
            >
              {t('age_verification.accept')}
            </button>
            {/* Bouton Non */}
            <button
              onClick={handleDecline}
              className="w-full font-sans tracking-wide rounded-xl py-3.5 text-stone-500 border transition-all duration-300 hover:border-stone-400 hover:text-stone-700"
              style={{ borderColor: 'rgba(120,90,40,0.25)', backgroundColor: 'transparent' }}
            >
              {t('age_verification.decline')}
            </button>
          </div>

          <p className="font-nunito text-xs text-stone-400 mt-6">
            L'abus d'alcool est dangereux pour la santé. À consommer avec modération.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AgeVerificationModal;